import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContextProvider } from 'react-dnd';
import { rootReducer, initialState } from './redux/reducers';
import { App } from './containers/App';

export const store = configureStore({
  reducer: rootReducer,
  middleware: [thunk],
  preloadedState: initialState,
  devTools: process.env.NODE_ENV !== 'production',
});

ReactDOM.render(
  <Provider store={store}>
    <DragDropContextProvider backend={HTML5Backend}>
      <Router>
        <App />
      </Router>
    </DragDropContextProvider>
  </Provider>,
  document.getElementById('root')
);
